import { render, staticRenderFns } from "./entradaRacao.vue?vue&type=template&id=c92fef60&scoped=true&"
import script from "./entradaRacao.vue?vue&type=script&lang=js&"
export * from "./entradaRacao.vue?vue&type=script&lang=js&"
import style0 from "./entradaRacao.vue?vue&type=style&index=0&id=c92fef60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c92fef60",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAutocomplete,VFlex,VForm,VLayout,VTextField})
